import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import { push } from 'redux-first-history';

import { MODAL_OPEN } from 'redux/slices/modals';

import routes from 'routing/routes';
import ModalLogout from 'ui/components/Modals/Logout';
import MainFont from 'ui/typography/mainFont';

import { IconWrapper, ListItem, PopupWrapper } from './style';

const AccountSettingsPopup = ({
  handleClose,
  openLogoutModal,
  pushUrl,
  role
}) => {
  const { t } = useTranslation();

  const handleAccountClick = () => {
    pushUrl(routes.accountManagement.path);
    handleClose();
  };

  const handleLogout = () => {
    handleClose();
    openLogoutModal();
  };

  return (
    <PopupWrapper>
      <ListItem onClick={handleAccountClick}>
        <IconWrapper className="icon-pp-people" />
        <MainFont
          type="accountPopupText"
          configuration={{ fontWeight: 'medium' }}
        >
          {t('account')}
        </MainFont>
      </ListItem>

      <ListItem onClick={handleLogout}>
        <IconWrapper className="icon-logout" />
        <MainFont
          type="accountPopupText"
          configuration={{ fontWeight: 'medium' }}
        >
          {t('log_out')}
        </MainFont>
      </ListItem>
    </PopupWrapper>
  );
};

AccountSettingsPopup.propTypes = {
  openLogoutModal: PropTypes.func,
  pushUrl: PropTypes.func,
  handleClose: PropTypes.func,
  role: PropTypes.string
};

export default connect(
  ({ authentication }) => ({ role: authentication.role }),
  dispatch => ({
    openLogoutModal: () => dispatch(MODAL_OPEN({ id: ModalLogout.id })),
    pushUrl: url => dispatch(push(url))
  })
)(AccountSettingsPopup);
